// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","button":"button-module--button--_fAcU"};